export const environment = {
  production: true,
  authUrl: 'https://prod-imageone-api-core-cu.azurewebsites.net',
  apiUrl: 'https://prod-imageone-api-core-cu.azurewebsites.net/api/v1',
  CLIENTAPPURL: 'https://prod-imageone-app-clients-cu.azurewebsites.net/main.js',
  EMPLOYEEAPPURL: 'https://prod-imageone-app-employees-cu.azurewebsites.net/main.js',
  HOMEAPPURL: 'https://prod-imageone-app-home-cu.azurewebsites.net/main.js',
  ACCOUNTAPPURL: 'https://prod-imageone-app-accounting-cu.azurewebsites.net/main.js',
  SETTINGAPPURL: 'https://prod-imageone-app-settings-cu.azurewebsites.net/main.js',
  LEADAPPURL: 'https://prod-imageone-app-leads-cu.azurewebsites.net/main.js',
  FRANCHISEAPPURL: 'https://prod-imageone-app-franchisee-cu.azurewebsites.net/main.js',
  OPERATIONAPPURL: 'https://prod-imageone-app-operation-cu.azurewebsites.net/main.js',
  REPORTINGAPPURL: 'https://prod-imageone-app-reporting-cu.azurewebsites.net/main.js',
  TRAININGAPPURL: 'https://prod-imageone-app-training-cu.azurewebsites.net/main.js',
  proposalUrl: 'https://proposalimageoneusa.com/',
  passport: {
    'client_id' : '2',
    'client_secret' : 'j0dj3QlTSGxdvCnkzmvcsqzCHD1U0EszRFrndNhD'
  },
  DEVELOPMENTTITLE: '',
  SENTRY_DNS: 'https://9d20b0fa2ad18a2cc72f33be72b3cb3e@o4507893033533440.ingest.us.sentry.io/4508328976973824'
};
